import { spinnerStyles } from 'style/spinnerStyles';

export default theme => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '16px'
  },
  formField: {
    marginBottom: '16px'
  },
  buttonContainer: {
    marginTop: '24px',
    display: 'flex',
    justifyContent: 'flex-end'
  },
  headerLogoWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '32px',
    marginTop: '16px',
    width: '100%'
  },
  headerLogo: {
    height: '48px',
    width: 'auto',
    filter: 'grayscale(100%)'
  },
  signUp: {
    marginTop: 20,
    fontSize: 11,
    color: '#6b6b6b'
  },
  ...spinnerStyles(theme)
});
